import { RefreshCw, LogOut } from 'lucide-react';
import './Navbar.css';

function Navbar({ lastUpdate, onRefresh, refreshing, user, onLogout }) {

  function formatTimestamp(date) {
    if (!date) return 'N/A';
    const diff = Math.floor((new Date() - date) / 1000);
    if (diff < 10)   return 'à l\'instant';
    if (diff < 60)   return `il y a ${diff}s`;
    if (diff < 3600) return `il y a ${Math.floor(diff / 60)}min`;
    return date.toLocaleTimeString('fr-FR');
  }

  return (
    <nav className="navbar">

      <div className="navbar-brand">
        <span className="navbar-wordmark">
          Monitoring <span className="navbar-wordmark-accent">Diese</span>
        </span>
      </div>

      <div className="navbar-right">
        <div className="navbar-timestamp">
          <span className="navbar-timestamp-dot" />
          Màj {formatTimestamp(lastUpdate)}
        </div>

        <button className="navbar-refresh" onClick={onRefresh} disabled={refreshing}>
          <RefreshCw size={13} className={refreshing ? 'spin' : ''} />
          Actualiser
        </button>

        {user && (
          <div className="navbar-user">
            <span className="navbar-user-name">{user.nom || user.email}</span>
            <button className="navbar-logout" onClick={onLogout} title="Se déconnecter">
              <LogOut size={14} />
            </button>
          </div>
        )}
      </div>

    </nav>
  );
}

export default Navbar;
